<form [formGroup]="form" class="hearing-language-support-step">
  <app-pill-choice
    [control]="form.controls.onFirstSounds"
    [label]="onFirstSoundsLabel"
    [required]="true"
    [errorText]="'SERVICE_PLAN.VALIDATION.ON_FIRST_SOUNDS_REQUIRED' | translate"
  />

  <app-tile-group
    *ngIf="showFirstSoundsYear"
    [control]="form.controls.firstSoundsYear"
    [options]="firstSoundsYearOptions"
    [label]="firstSoundsYearLabel"
    [required]="true"
    [errorText]="
      'SERVICE_PLAN.VALIDATION.FIRST_SOUNDS_YEAR_REQUIRED' | translate
    "
  />

  <app-tile-group
    *ngIf="showLslFrequency"
    [control]="form.controls.lslFrequency"
    [options]="lslFrequencyOptions"
    [label]="lslFrequencyLabel"
    [required]="true"
    [errorText]="'SERVICE_PLAN.VALIDATION.LSL_FREQUENCY_REQUIRED' | translate"
  />

  <app-pill-choice
    *ngIf="showClinicalFrameworkMatch"
    [control]="form.controls.clinicalFrameworkMatch"
    [label]="clinicalFrameworkMatchLabel"
    [required]="true"
    [errorText]="
      'SERVICE_PLAN.VALIDATION.CLINICAL_FRAMEWORK_MATCH_REQUIRED' | translate
    "
  />

  <app-textarea
    *ngIf="showMismatchReason"
    [control]="form.controls.clinicalFrameworkMismatchReason"
    [label]="clinicalFrameworkMismatchReasonLabel"
    [required]="isMismatchReasonRequired"
    [errorText]="
      'SERVICE_PLAN.VALIDATION.CLINICAL_FRAMEWORK_MISMATCH_REASON_REQUIRED'
        | translate
    "
  />
</form>
